import { components, type SingleValue } from 'react-select';
import { ColorIndicator, FilterSelect } from '..';
import { jerseyOptions as allJerseyOptions } from '../../shared/jersey-colors';

// Using any here because react-select is confusing
const JerseyOption = (props: any) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <div className="text-left">
        <ColorIndicator size="14px" color={data} /> {data.name}{' '}
        <small className="text-muted">({data.hex})</small>
      </div>
    </components.Option>
  );
};

interface ColorObject {
  hex: string;
  name: string;
}

// Note: these props are likely inaccurate since they are typed as "any" in GroupTeamForm.tsx

interface Props {
  /** Strings of color names to omit from the options */
  omitColors: string[];
  /**
   * List of jersey colors that can be selected. If not provided, list all available colors. */
  options?: ColorObject[];
  /** Callback function when a color is selected */
  onSelect: (color: SingleValue<ColorObject>) => void;
}

const JerseySelectorV2 = (props: Props) => {
  const {
    omitColors, // optional - used to filter out options
    options,
    onSelect,
  } = props;

  const comps = {
    Option: JerseyOption,
    // @ts-expect-error - library not typed well
    ...components.propsComponents,
  };

  const availColorOptions = (options || allJerseyOptions)
    .filter(({ name }) => !omitColors.includes(name))
    .map(({ name, hex }) => ({ name, hex }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <FilterSelect
      border
      withDropdown
      placeholder="Select a Color"
      components={comps}
      // No `value` prop needed. Might be worth adding in the future?
      CustomOption={JerseyOption}
      options={availColorOptions}
      getOptionLabel={({ name }) => name}
      onChange={opt => onSelect(opt)}
    />
  );
};

export default JerseySelectorV2;
